import React from 'react'

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className = '', children, required, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={`text-white text-[20px] font-bold leading-none ${className}`}
        {...props}
      >
        {children}
        {required && <span className="text-pcg-danger ml-1">*</span>}
      </label>
    )
  }
)

Label.displayName = 'Label'